import { Button } from "@mantine/core";
import VidLibraryButton from "../VidLibraryButton/VidLibraryButton";
import { timeToComplete } from "../utils";
import { AppResources } from "@/constants.ts";
import DemoSubHeader from "./DemoSubHeader/DemoSubHeader";

const DemoHeader = () => {
  return (
    <div className="demo-header-container">
      <div className="demo-header">
        <div className="demo-header-item-first">
          <div className="demo-item-label">
            <h2>Ready to unlock your full potential?</h2>
            <p>
              Deep dive on how SmartWiz works and discover how to maximize your
              business using our software.
            </p>
            {timeToComplete("10")}
          </div>
          <div className="demo-item-btns">
            <div className="demo-item-btn">
              <Button
                component="a"
                href="https://app.supademo.com/demo/cm2c246rb1hyavm5sn0oh8ejv"
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                mt="md"
                className="start-tutorial-btn"
                radius="md"
              >
                Start the tutorial
              </Button>
            </div>

            <img
              className="banner-img"
              src={AppResources.demoHeader}
              alt="vid-lib"
            />
          </div>
        </div>

        <div className="demo-header-item-second">
          <div className="demo-item-label">
            <h2>Want to learn more?</h2>
            <p>
              View our video library with topics on tax foundations and filing
              returns on TaxWise.
            </p>
          </div>
          <div className="demo-item-btns">
            <div className="demo-item-btn">
              <VidLibraryButton />
            </div>
            <img
              className="banner-img"
              src={AppResources.demoHeaderVideo}
              alt="vid-lib"
            />
          </div>
        </div>
      </div>

      <DemoSubHeader />
    </div>
  );
};

export default DemoHeader;
